import { fmhAPI, PRIOR_AUTH_MANAGER_API_URL } from 'api/APIBase';

/** Posts a new prior auth submission */
export async function postPriorAuthorization({ payerId, authBody }) {
    const url = `${PRIOR_AUTH_MANAGER_API_URL}/${payerId}/auths`;
    return fmhAPI.base.url(url).post(authBody).json();
}
